import {
	UseBaseQueryOptions,
	keepPreviousData,
	useQuery,
} from '@tanstack/react-query'
import { getOverallAnalyticsAggregate } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetOverallAnalyticsAggregateResponse,
	GetOverallAnalyticsRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetOverallAnalyticsAggregate(
	payload: GetOverallAnalyticsRequest,
	props?: UseBaseQueryOptions<GetOverallAnalyticsAggregateResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.OverallAnalyticsAggregate, payload],
		queryFn: () => getOverallAnalyticsAggregate(payload),
		placeholderData: keepPreviousData,
		...props,
	})
}
